export function $can (perms, user) {
  user = !user && window.localStorage.user ? JSON.parse(window.localStorage.user) : user
  if (!user) return false
  if (user.role === 'superadmin') return true
  let permissions = perms.split('|').map(item => item.toLowerCase())
  for (let p of permissions) {
    if (user.permissions && user.permissions.map(item => item.toLowerCase()).indexOf(p) >= 0) {
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/mixins/can.js